import axios from 'axios';
import { 
    API_BASE_URL 
} from 'src/common/constants';

export default class WebinarService {
	static getInstance() {
		if (!WebinarService.instance) {
			WebinarService.instance = new WebinarService();
		}

		return WebinarService.instance;
	}

	async fetchList(params = {}) {
		const response = await axios.get(`${API_BASE_URL}/webinar/list`, {
            params: params,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
			}
		});

        return response.data?.data;
    }
}
